import { supabase } from "@/integrations/supabase/client";

export const useDataFetching = () => {
  const fetchOrganizationData = async (organizationId: string, agentId?: string) => {
    let behaviors = [];
    let knowledgeItems = [];

    if (!organizationId) {
      console.warn(
        "No organization ID available, skipping behaviors and knowledge fetch"
      );
      return { rules: [], knowledgeItems: [] };
    }

    console.log(
      `Attempting to fetch knowledge for organization: ${organizationId}${agentId ? ` and behaviors for agent: ${agentId}` : ''}`
    );

    try {
      // Fetch behaviors by agent_id if provided, otherwise don't fetch behaviors
      if (agentId) {
        const { data: behaviorsData, error: behaviorsError } = await supabase
          .from("behaviors")
          .select("*")
          .eq("agent_id", agentId)
          .eq("is_active", true);

        if (behaviorsError) {
          console.error("Error fetching behaviors:", behaviorsError);
        } else if (behaviorsData) {
          behaviors = behaviorsData;
          console.log(`Fetched ${behaviors.length} active behaviors for agent ${agentId}`);
        } else {
          console.log("No behaviors data returned from the query");
        }
      } else {
        console.log("No agent ID provided, skipping behaviors fetch");
      }
    } catch (behaviorsFetchError) {
      console.error("Exception during behaviors fetch:", behaviorsFetchError);
    }

    try {
      // Fetch knowledge items
      const { data: knowledgeData, error: knowledgeError } = await supabase
        .from("knowledge_items")
        .select("*")
        .eq("organization_id", organizationId)
        .eq("is_active", true);

      if (knowledgeError) {
        console.error("Error fetching knowledge items:", knowledgeError);
      } else if (knowledgeData) {
        knowledgeItems = knowledgeData;
        console.log(
          `Fetched ${knowledgeItems.length} knowledge items for organization`
        );
      } else {
        console.log("No knowledge data returned from the query");
      }
    } catch (knowledgeFetchError) {
      console.error("Exception during knowledge fetch:", knowledgeFetchError);
    }

    return { behaviors, knowledgeItems };
  };

  const extractFormFields = async (conversationId: string, agentId: string) => {
    try {
      console.log(
        "Calling extract-form-fields function for conversation:",
        conversationId
      );

      const { data, error } = await supabase.functions.invoke(
        "extract-form-fields",
        {
          body: {
            conversationId,
            agentId,
            format: "json_object", // Updated to use correct format parameter
          },
        }
      );

      if (error) {
        console.error("Error calling extract-form-fields function:", error);
        return { success: false, error };
      }

      console.log("Form fields extraction result:", data);
      return { success: true, data };
    } catch (err) {
      console.error("Exception calling extract-form-fields function:", err);
      return { success: false, error: err };
    }
  };

  return {
    fetchOrganizationData,
    extractFormFields,
  };
};
